"use strict";
const _ = require('lodash');
function userHasFortnox(sessionUser) {
    return !!_.get(sessionUser, 'integrationConfig.integrations', []).find(x => x.type === 'FORTNOX');
}
module.exports = { userHasFortnox };
